// extracted by mini-css-extract-plugin
export default {"list":"UnlinkCardConfirmModal__list--37_I1"};